import { UserRole } from '@/enums/UserRole';

/**
 * Paths allowed per role. ADMIN has unrestricted access ('*').
 * Each path entry matches exact path or any descendant (prefix match).
 */
export const roleAllowedPaths: Record<UserRole, string[] | '*'> = {
  [UserRole.ADMIN]: '*',
  [UserRole.DESIGNER]: [
    '/api',
    '/my-maps',
    '/templates',
    '/pdf-template-creator',
    '/html-template-creator',
    '/sms-template-creator',
    '/whatsapp-template-creator',
    '/jobs',
    '/dash',
  ],
  [UserRole.OPERATOR]: ['/api', '/dash'],
};

/**
 * Default redirect path when a role is denied access.
 */
export const roleDefaultPath: Record<UserRole, string> = {
  [UserRole.ADMIN]: '/home',
  [UserRole.DESIGNER]: '/my-maps',
  [UserRole.OPERATOR]: '/dash/comunicacoes',
};

export function isPathAllowed(pathname: string, role: UserRole): boolean {
  const allowed = roleAllowedPaths[role];
  if (allowed === '*') return true;
  return allowed.some((path) => pathname === path || pathname.startsWith(path + '/'));
}
